
"use strict";

import $ from 'jquery';
import Gumshoe from 'gumshoejs';

export default class SideBar {

  constructor(element) {
    if (!element) {
      return;
    }

      let stickySidebar = document.createElement('div');
      stickySidebar.classList.add('sticky-sidebar');
      stickySidebar.classList.add('col-3');
      element.prepend(stickySidebar);

      document.addEventListener('scroll', () => {
          stickySidebar.style.top = $(".main-nav-holder").height() + 'px';
      });

    this.headingList = this.setHeadinglist(element);
    this.links = this.setLinks();

    this.setNav(element);

    this.setScrollspy();


  }
  setScrollspy() {
    var header = document.querySelector(".main-nav-holder");
    var spy = new Gumshoe(".sticky-sidebar a", {
      offset: function() {
        return header.getBoundingClientRect().height + 30;
      },
        contentClass: 'current',
    });

  }
  setHeadinglist(element) {
    let $headings = $('h1,h2,h3,h4,h5,h6', $(element));
    if ($headings) {
      let $headingList = [];
      $headings.each(function (index) {
        let $id = 'h' + index;
        let $text = $(this).text();

        $(this).attr('id', $id);


        let entry = { id: $id, text: $text };
        $headingList.push(entry);

      });

      return $headingList;

    }

  }
  setLinks() {
    let $links = [];

    $(this.headingList).each(function () {
      let $text = this.text;

      let $link = $("<a class='nav-link'></a>")
        .attr("href","#"+this.id)
        .text($text);           
      $links.push($link); 
    });
    return $links;
  }
  setNav(element) {
    let links = $(this.links);
    let $ul = $("<ul class='navbar-nav'></ul>");


    links.each(function (index) {
      let navItem = $("<li class='nav-item'></li>");
      this.appendTo(navItem);
      navItem.appendTo($ul);
    });
    
    $('a', $ul).unbind();
    $("a", $ul).click(function(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

      var target = $(this.hash),
        headerHeight = $(".main-nav-holder").height() + 10; // Get fixed header height

      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top - headerHeight
          },
          500
        );
        return false;
      }

        return false;
    });
    
    

    $($ul).appendTo($('.sticky-sidebar', element));

  }

}
